/**
 * Which of the two surfaces this page is.
 *
 * One build is served at both hostnames. `config.instec.llc` is the
 * configuration studio - the field library and the product builder;
 * `portal.instec.llc` is where applications are filled in. Locally there is no
 * hostname to read, so the dev server stamps it in at build time: port 5180 is
 * the portal, 5181 the studio.
 *
 * This decides only what is *shown*. What a user may actually do is decided by
 * their role on the server, every request, and loading the studio without the
 * role gets you a polite refusal from the API rather than a working page.
 */
declare const __DEV_SURFACE__: string;

export type Surface = "portal" | "config";

export const SURFACE_NAMES: Record<Surface, string> = {
  portal: "Dynamic Portal",
  config: "Product Configuration",
};

export function resolveSurface(): Surface {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host.startsWith("config.")) return "config";
    if (host.startsWith("portal.")) return "portal";
  }
  return __DEV_SURFACE__ === "config" ? "config" : "portal";
}

export const surface = resolveSurface();
